export function escapeAttr(s: string): string {
  return s.replace(/"/g, '&quot;');
}

export interface RenderInputOptions {
  name: string;
  type: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  options?: Array<{ value: string; label: string }>;
  inputClass?: string;
  textareaClass?: string;
  selectClass?: string;
}

export function renderInputHtml(opts: RenderInputOptions): string {
  const {
    name,
    type,
    value = '',
    placeholder = '',
    required = false,
    options = [],
    inputClass = 'ea-input',
    textareaClass = 'ea-textarea',
    selectClass = 'ea-select',
  } = opts;
  const req = required ? 'required' : '';

  if (type === 'textarea') {
    return `<textarea name="${name}" class="${textareaClass}" placeholder="${escapeAttr(placeholder)}" ${req}>${escapeAttr(value)}</textarea>`;
  }

  if (type === 'select') {
    const optHtml = options
      .map(
        o =>
          `<option value="${escapeAttr(o.value)}"${o.value === value ? ' selected' : ''}>${o.label}</option>`
      )
      .join('');
    return `<select name="${name}" class="${selectClass}" ${req}><option value="">请选择</option>${optHtml}</select>`;
  }

  return `<input type="${type}" name="${name}" value="${escapeAttr(value)}" class="${inputClass}" placeholder="${escapeAttr(placeholder)}" ${req} />`;
}
